import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/lock.css";

export default function LockScreen() {
  const [pin, setPin] = useState("");
  const [message, setMessage] = useState("");
  const [storedPin, setStoredPin] = useState(null);
  const [error, setError] = useState("");

  const inputRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const savedPin = localStorage.getItem("pj_pin");
    setStoredPin(savedPin);
  }, []);

  const handleUnlock = () => {
    if (!storedPin) {
      localStorage.setItem("pj_pin", pin);
      setStoredPin(pin);
      setMessage("PIN set successfully. Please re-enter to unlock.");
      setPin("");
      setError("");
      return;
    }

    if (pin === storedPin) {
      setError("");
      navigate("/home");
    } else {
      setError("Incorrect PIN");
      setMessage("");
      setPin("");
    }
  };

  const handleChange = (e) => {
    // digits only
    const value = e.target.value.replace(/\D/g, "");
    setPin(value);
  };

  return (
    <div
      className="lock-container"
      onClick={() => inputRef.current.focus()}
    >
      <h1>PocketJournal</h1>
      <p>{storedPin ? "Enter PIN" : "Set your PIN"}</p>

      <div className="pin-circles">
        {[0, 1, 2, 3].map((i) => (
          <span
            key={i}
            className={pin.length > i ? "filled" : ""}
          ></span>
        ))}
      </div>

      {message && <p className="message">{message}</p>}

      <input
        ref={inputRef}
        type="password"
        inputMode="numeric"
        maxLength={4}
        value={pin}
        onChange={handleChange}
        autoFocus
      />

      <button onClick={handleUnlock} disabled={pin.length !== 4}>
        Unlock
      </button>

      {error && <p className="error">{error}</p>}
    </div>
  );
}
